<template>
    <div>
        <div class="splide" id="campaign-pictures" v-if="hasMultiple">
            <div class="splide__track mb-10px">
                <ul class="splide__list" data-cy="list_detail_picture_images">
                    <li class="splide__slide" v-for="(image, k) in imageList" :key="k">
                        <img class="w-full" :src="image.fullImageUrl" :data-cy="`img_detail_picture_item_${k}`" />
                    </li>
                </ul>
            </div>
            <DotNavigation :total="imageList.length" v-model="currentSlide"></DotNavigation>
        </div>
        <div v-else>
            <img v-if="imageList.length > 0" class="w-full" :src="imageList[0].fullImageUrl" data-cy="img_detail_picture_single" />
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
import DotNavigation from '@/components/Slider/DotNavigation.vue';

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    components: {
        DotNavigation
    },
    data: function () {
        return {
            currentSlide: 0
        }
    },
    computed: {
        hasMultiple: function () {
            return this.imageList.length > 1
        },
        isGold: function () {
            if (this.$route.query.platinum != undefined) {
                return false
            }

            return true
        },
        imageList: function () {
            if (this.campaign != null && this.campaign.pictures != null) {
                return this.campaign.pictures;
            }
            return []
        }
    },
    mounted: function () {
        if (this.hasMultiple) {
            this.$nextTick(() => {
                setTimeout(() => {
                    new Splide('#campaign-pictures', {
                        type: 'loop',
                        arrows: false,
                        pagination: false,
                    })
                        // eslint-disable-next-line no-unused-vars
                        .on("move", (newIdx, prevIdx, destIdx) => {
                            // console.log(newIdx, prevIdx, destIdx)
                            this.currentSlide = newIdx
                        })
                        .mount();

                }, 100);
            })
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
